import { IModuleDetail, IModuleEvent, IPeriod, IExamEvent } from '../models/grade-models';
import { ModuleDetail, ModuleEvent, Period, ExamEvent } from '../models/grade-viewmodels';

/**
 * Mapper for the Grade Detail service
 */

export default class GradeDetailMapper {
    private bookableNotAvailable(item: IModuleDetail): boolean {
        return !(item &&
                item.period &&
                (item.period.isBookable || (item.hasLastMinuteRegistrations && item.period.isLastMinuteBookable))) &&
                item.isSelfRegistration &&
                !item.period.isPlannable;
    }

    public mapGradeDetail(item: IModuleDetail): ModuleDetail {
        return new ModuleDetail(
            item.description,
            item.isPlanned,
            item.hasResult,
            item.moduleEvents.map(entry => this.mapModuleEvent(entry)),
            this.mapPeriod(item.period),
            item.moduleCode,
            item.credits,
            item.hasRules,
            item.isExCur,
            item.examEvents.map(entry => this.mapExamEvent(entry)),
            item.isEditable,
            item.hasLastMinuteRegistrations,
            this.bookableNotAvailable(item),
            item.studyLinkUrl
        );
    }

    public mapModuleEvent(item: IModuleEvent): ModuleEvent {
        return new ModuleEvent(
            item.id,
            item.code,
            item.type,
            item.description
        );
    }

    public mapExamEvent(item: IExamEvent): ExamEvent {
        return new ExamEvent(
            item.id,
            item.offerNumber,
            item.date,
            item.requireExtraTime,
            item.extraTimeEditable
        );
    }

    public mapPeriod(item: IPeriod): Period {
        return new Period(
            item.isPlannable,
            item.isBookable,
            item.description,
            item.isLastMinuteBookable
        );
    }
}